import * as THREE from "three";

import {Engine, isDeviceMobile, getSearchParameters} from './engine';
import {Response, Ask, Hover, Move, Start, Strategy} from './message';


let urlParameters = getSearchParameters();
let url = "/assets/output/model.mpd";
let box = new THREE.Box3(
    new THREE.Vector3(-14228.7, -7614.23, 2584.92),
    new THREE.Vector3(-147.666, 9160.32, 20710.6),
);
let strategy: Strategy = urlParameters.strategy === "bookmark" ? "Bookmark" : "Greedy";
let position = new THREE.Vector3(164.4867179222107, -6.331098624716404, -145.1722345572967);
let clearColor = 0xabcdef;
let isMobile = isDeviceMobile();

let ty : 'Desktop' | 'Mobile' | 'Mobile1' = isMobile ? 'Mobile' : 'Desktop';

if (urlParameters.device === 'mobile') {
    ty = 'Mobile';
} else if (urlParameters.device === 'simple-mobile') {
    ty = 'Mobile1';
}
console.log(ty);
let engine = new Engine({
    position,
    box,
    clearColor,
    device: ty,
    startAtFirstInteraction: false,
});
engine.model.newSegment();

engine.addEventListener('hover', (name) => {
    worker.postMessage(new Hover(name));
});

engine.addEventListener('move', (name) => {
    worker.postMessage(new Move(name));
});

let worker = new Worker("js/worker.js");
worker.addEventListener('message', (m) => {
    let message = m.data as Response;
    engine.model.newSegment();
    engine.model.addElements(message.elements);
    worker.postMessage(new Ask(engine.camera));
});

document.addEventListener('keydown', (event) => {
    if (event.key === "k") {
        kill();
    }
});

engine.addToElement(document.body);
engine.start();
engine.addEventListener('first', () => {
    worker.postMessage(new Start(url, box, strategy));
});
engine.addEventListener('hover', (name) => {
    worker.postMessage(new Hover(name));
});
engine.addEventListener('move', (name) => {
    worker.postMessage(new Move(name));
});

function kill() {
    engine.kill();
    worker.terminate();
}

